import { ReactNode } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * 他システムから呼び出されるエンドポイント
 */
export function Initialize(): ReactNode {
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirectPage');

  return <Navigate to={`/${redirectTo ?? ''}`} replace />;
}
